<template>
    <div>
        <img
                class="img-fluid img-logo"
                src="@/assets/img/Logo Novo ConstrUp.png"
                alt="Logo Constr Up"
                width="300px"
                height="300px"
            />
            <hr>
        <h2 class="text-center mb-3">Esqueceu a senha?</h2>
        <p class="text-center fs-20 passwordText">Informe seu e-mail no campo abaixo e <br>
        enviaremos instruções para você recuperar a <br>
        sua senha.
        </p>
        <div class="content-passwrd">
            <br>
            <form>
                <input class="email-field" type="email" v-model="email" required placeholder="Seu E-mail aqui"> <br> <br>
                <button @click.prevent="emailPasswrd()" class="button-email">Recuperar senha</button>
            </form>
        </div>
    </div>
</template>
<script>
import makeToast from '../mixins/makeToast';
export default {
    mixins: [makeToast],
    data() {
        return {
            email: null,
        }
    },
    methods: {
        emailPasswrd() {
            this.$store.dispatch('startLoader');
            const data = {
                'info': this.email
            }
            this.$store
                .dispatch('login/sendEmail', data)
                .then(() => {
                    this.$bvModal.show('login2')
                    this.$store.dispatch('endLoader');
                    this.makeToast('Sucesso!', 'verifique a sua caixa de e-mail!', 'success')
                    this.$bvModal.hide('rescuePasswrd');
                })
                .catch(() => {
                    this.$store.dispatch('endLoader');
                    this.makeToast('Oopss', 'E-mail não cadastrador ou E-mail inválido!', 'danger')
                })
        },
    },
}
</script>
<style scoped>
.title-passwrd {
    color: #ED670C;
    text-align: center;
}
.button-email {
    padding: 7px;
    border-radius: 3px;
    background: #ED670C;
    color: white;
    width: 300px;
    font-size: 25px;
    text-align: center;
    border: none;
    margin-bottom: 15px;
}
.content-passwrd {
    display: flex;
    justify-content: center;
    align-items: center;
}
.img-logo {
    display: block;
    margin-left: auto;
    margin-right: auto
}
.email-field {
    margin-top: 20px;
    padding: 5px;
    border-radius: 3px;
    width: 300px;
    border: 1px solid #e5e5e5;
}
.passwordText{
    font-size: 15px;
}
</style>